<template>
  <div class="text-center">
    <div class="content">
      <div style="margin-bottom: 140px" class="flex flex-wrap mb-4">
        <div class="w-full">
          <h1 class="mb-6 text-center big-title">
            Complimenti! Hai completato la richiesta della tua nuova carta!
          </h1>

          <img
            class="reg-completed-img"
            src="../../assets/images/tutore_ok.png"
          />

          <div class="info-box mt-5">
            <p class="f-b">I prossimi step:</p>
            <ul class="text-grey">
              <li>
                Abbiamo inviato una notifica in App al tuo tutore/genitore.
              </li>
              <li>
                Non appena il tuo tutore avrà completato la procedura di
                approvazione in App, procederemo con l'emissione della carta e
                ti invieremo un'email di conferma
              </li>
              <li>
                Riceverai la tua carta Tinaba, già attiva, all'indirizzo che hai
                indicato e potrai iniziare subito ad utilizzarla per qualsiasi
                pagamento in punti vendita fisici e online e per prelevare
                contanti presso tutti gli sportelli atm. Potrai ricaricare la
                carta direttamente dall'app in modo gratuito e istantaneo!
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- wait until userSubscribedAnyPlan is evalued -->
    <div v-if="userSubscribedAnyPlan !== null" class="page-footer">
      <!-- if user requested an influencer card but still doesn't have the related plan
          we redirect him to the plan activation page -->
      <button
        v-if="userIsRequestingInfluencerCard && !userSubscribedAnyPlan"
        class="btn"
        @click="goToProfileActivation"
      >
        Ho capito
      </button>
      <button v-else class="btn" @click="backToInitialView">
        Torna alla schermata iniziale
      </button>
    </div>
  </div>
</template>

<script>
import UtilityService from "@/services/UtilityService";
import ApiService from "@/services/ApiService";
import RegistrationService from "@/services/RegistrationService";

export default {
  name: "MinorRegistrationCompleted",

  data() {
    return {
      userSubscribedAnyPlan: null
    };
  },
  computed: {
    userIsRequestingInfluencerCard: function() {
      return (
        this.$store.state.registrations?.prepaidCardResource?.profile &&
        this.$store.state.registrations?.prepaidCardResource?.profile !== "BASE"
      );
    }
  },
  async mounted() {
    if (this.$store.state.registrations.id !== undefined) {
      this.init();
    } else {
      this.$root.$on("appIsReady", this.init);
    }
  },
  methods: {
    async init() {
      this.isUpgrade = sessionStorage.getItem("upgrade") !== null;
      this.userSubscribedAnyPlan = await RegistrationService.userSubscribedAnyPlan();

      this.$root.$emit("openGlobalLoader");
      try {
        const response = await ApiService.get(`/usr/v2/prepaid-cards/`);
        this.currentCard = response.data?.filter(
          c => c.id === this.$store.state.registrations.prepaidCardResource.id
        )[0];
        this.$root.$emit("closeGlobalLoader");
      } catch (error) {
        this.$root.$emit("closeGlobalLoader");
        UtilityService.showDefaultError(error);
      }
    },
    goToProfileActivation() {
      UtilityService.goToProfileActivation(this.currentCard.id);
    },
    backToInitialView() {
      UtilityService.backToInitialView();
    }
  }
};
</script>
<style lang="less" scoped>
.reg-completed-img {
  width: 200px;
  margin: 20px auto;
}
.info-box {
  text-align: left;
  max-width: 515px;
  p {
    margin-bottom: 22px;
  }
  ul {
    margin-left: 20px;
    list-style: initial;
  }
}
.info-card-box {
  margin-top: 160px;
  display: flex;
  height: 100%;
  align-items: center;
  text-align: left;
  .card {
    position: relative;
    .card__box {
      width: 300px;
    }
  }
  img {
    width: 200px;
    position: absolute;
    top: -90px;
    left: 100px;
  }
}
</style>
